import { render, staticRenderFns } from "./SharedComunicationView.vue?vue&type=template&id=9a15a2c2&scoped=true&lang=pug&"
import script from "./SharedComunicationView.vue?vue&type=script&lang=js&"
export * from "./SharedComunicationView.vue?vue&type=script&lang=js&"
import style0 from "./SharedComunicationView.vue?vue&type=style&index=0&id=9a15a2c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a15a2c2",
  null
  
)

export default component.exports